import { useParams } from 'react-router-dom';
import { CheckboxToggle } from 'react-rainbow-components';
import { Phonenumber } from 'data/firestore/phonenumber/types';
import useManagePhoneNumbers from 'data/hooks/useManagePhoneNumbers';
import { ActionsCellWrapper } from './styled';

interface Props {
    row?: Phonenumber;
}

const SmsSenderColumn = ({
    row,
}: Props) => {
    const { agentId = '' } = useParams();
    const { setSmsSender } = useManagePhoneNumbers({ agentId });

    if (!row) return null;

    return (
        <ActionsCellWrapper>
            <CheckboxToggle
                value={row.isDefaultSmsSender || false}
                labelAlignment="left"
                onChange={(event) => setSmsSender(row.id, event.target.checked)}
            />
        </ActionsCellWrapper>
    );
};

export default SmsSenderColumn;
